import { computed } from 'vue-demi';
import { PlateMap, PlateId, MARKET_VAL, JP_ETF } from '../assets/config/index';


export default (props, request) => {
    // 市值榜或是日股 ETF 榜消费板块的接口
    const isMarketValRank = computed(() => props.sort_id === MARKET_VAL || props.sort_id === JP_ETF);

    const getMarketValRank = async () => {
        let plateId = '';
        if (props.sort_id === JP_ETF){
            // 单独处理日股 ETF
            plateId = PlateId.JP_ETF;
        } else {
            // 通过股票市场映射到对应的板块 market_id -> plate_id
            plateId = PlateMap[props.market_id];
        }

        const data = {
            plate_id: plateId,
            lang: props.language,
            count: props.count,
            increaseType: props.increaseType,
        };
        try {
            const r = await request.get('get-market-val-list', data);
            return r;
        } catch (err) {
            console.log('market-val-rank', err);
        }
    };

    const isHotDividendsRanking = computed(() => props.sort_id === 'ttm');

    const getHotDividendsRanking = async () => {
        const data = {
            market_id: props.market_id,
            lang: props.language,
            count: props.count,
        };
        try {
            const r = await request.get('get-hot-dividends-rank-list', data);
            return r;
        } catch (err) {
            console.log('market-val-rank', err);
        }
    };

    return {
        isMarketValRank,
        isHotDividendsRanking,
        getMarketValRank,
        getHotDividendsRanking
    };
};
